const TYPES = new Set(['library_ready', 'library_error', 'request', 'response', 'empty', 'error', 'deadline', 'render', 'viewable', 'internal_fallback'])
const FAMILIES = new Set(['editor', 'learning', 'seo_download', 'nexo'])
// Local lifecycle diagnostics only. No network beacon, identifiers, code or monetary claims.
export function emitAdEvent(type, { pageFamily, placement, reason, durationMs, width, height, position, experiment, variant, device, selectedSize, eligible } = {}) {
  if (!TYPES.has(type) || typeof window === 'undefined') return
  const detail = { type, pageFamily: FAMILIES.has(pageFamily) ? pageFamily : 'editor', placement: String(placement || '').replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 60) }
  if (reason) detail.reason = String(reason).replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 60)
  if (Number.isFinite(durationMs)) detail.durationMs = Math.round(durationMs)
  if (Number.isFinite(width)) detail.width = width
  if (Number.isFinite(height)) detail.height = height
  if (position) detail.position = String(position).replace(/[^a-zA-Z0-9_.-]/g, '').slice(0, 100)
  if (experiment) detail.experiment = String(experiment).replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 60)
  if (['control', 'treatment'].includes(variant)) detail.variant = variant
  if (['desktop', 'mobile'].includes(device)) detail.device = device
  if (/^\d{2,4}x\d{2,4}$/.test(selectedSize || '')) detail.selectedSize = selectedSize
  if (typeof eligible === 'boolean') detail.eligible = eligible
  window.dispatchEvent(new CustomEvent('visualg:ad-lifecycle', { detail }))
}
